// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"e3-z","sponsoredTooltipWrapper":"f3-z","sponsoredTooltip":"g3-z","newCard":"h3-z"};